module.exports = __webpack_public_path__ + "img/recruitment1.3b4d70b6.png";